import { DatePicker, Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TextField, IconButton, Dialog, FlatButton } from 'material-ui';
import React, { useEffect, useState } from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import useDebounce from 'helpers/useDebounce';
import api from 'services';
import _ from 'lodash';
import moment from 'moment';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

function getDefaultDetention() {
    return {
        _id: '',
        detained: null,
        released: null,
        port: {
            _id: '',
            name: '',
            country: {
                _id: '',
                name: '',
            },
        },
        deficienciesNumber: null,
        deficienciesNature: [],
    };
}

function Detentions({ detentions, changeField, clearDetentions }) {
    const [openNatureDialog, setOpenNatureDialog] = useState(false);
    const [currentDetentionDialogRow, setCurrentDetentionDialogRow] = useState(null);

    const selectPort = (port, index) => {
        changeField([
            {
                field: `detentions[${index}].port`,
                value: _.pick(port, ['_id', 'name']),
            },
            {
                field: `detentions[${index}].port.country`,
                value: port.country,
            },
        ]);
    };

    const setSelectedDate = (date, type, index) => {
        changeField([
            {
                field: `detentions[${index}].${type}`,
                value: date,
            }
        ]);
    };

    const removeDetention = (index) => {
        const _detentions = _.cloneDeep(detentions);

        _detentions.splice(index, 1);

        changeField([
            {
                field: 'detentions',
                value: _detentions,
            },
        ]);
    };

    const addDetention = () => {
        const _detentions = _.cloneDeep(detentions);

        _detentions.push(getDefaultDetention());

        changeField([
            {
                field: 'detentions',
                value: _detentions,
            },
        ]);
    };

    const handleOpenNatureDialog = (rowIndex = null, cellIndex = undefined) => {
        if ((cellIndex || cellIndex === 0) && cellIndex !== 5) {
            return;
        }

        setOpenNatureDialog(!openNatureDialog);
        setCurrentDetentionDialogRow(rowIndex);
    };

    return (
        <div>
            <Table
                selectable={false}
                onCellClick={(rowIndex, cellIndex) => handleOpenNatureDialog(rowIndex, cellIndex)}
            >
                <TableHeader
                    adjustForCheckbox={false}
                    displaySelectAll={false}
                >
                    <TableRow>
                        <TableHeaderColumn style={{ width: '15.5%', textAlign: 'center' }}>
                            Port
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: '15.5%', textAlign: 'center' }}>
                            Country
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: '9.5%', textAlign: 'center', padding: 0 }}>
                            Detained
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: '9.5%', textAlign: 'center', padding: 0 }}>
                            Released
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            style={{ width: '12%', whiteSpace: 'break-spaces', textAlign: 'center' }}
                        >
                            Number of Deficiences
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ width: '34%', textAlign: 'center' }}>
                            Nature of Deficiences
                        </TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: 'center' }} />
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                    <NatureDialog
                        changeField={changeField}
                        detention={detentions[currentDetentionDialogRow - 1]}
                        detentions={detentions}
                        detentionIndex={currentDetentionDialogRow - 1}
                        handleOpenNatureDialog={handleOpenNatureDialog}
                        openNatureDialog={openNatureDialog}
                    />
                    {
                        detentions && detentions.map((detention, index) => {
                            return (
                                <TableRow
                                    displayBorder
                                    key={`detention_${index}`}
                                >
                                    <TableRowColumn style={{ border: '1px solid #dfdfdf', width: '15.5%', padding: '0 5px' }}>
                                        <PortsAutoComplete
                                            index={index}
                                            key={`detention_port_${index}`}
                                            port={detention.port}
                                            selectPort={selectPort}
                                            clearDetentions={clearDetentions}
                                        />
                                    </TableRowColumn>
                                    <TableRowColumn style={{ border: '1px solid #dfdfdf', width: '15.5%', padding: '0 5px' }}>
                                        {detention.port.country && detention.port.country.name}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ border: '1px solid #dfdfdf', width: '9.5%', padding: '0 5px' }}>
                                        <DatesSelector
                                            type='detained'
                                            value={detention.detained}
                                            index={index}
                                            setSelectedDate={setSelectedDate}
                                            minDate={undefined}
                                            maxDate={detention.released && new Date(detention.released)}
                                        />
                                    </TableRowColumn>
                                    <TableRowColumn style={{ border: '1px solid #dfdfdf', width: '9.5%', padding: '0 5px' }}>
                                        <DatesSelector
                                            type='released'
                                            value={detention.released}
                                            index={index}
                                            setSelectedDate={setSelectedDate}
                                            minDate={detention.detained && new Date(detention.detained)}
                                            maxDate={undefined}
                                        />
                                    </TableRowColumn>
                                    <TableRowColumn style={{ border: '1px solid #dfdfdf', width: '12%', padding: '0 5px', textAlign: 'center' }}>
                                        {
                                            generateTextFields({
                                                value: detention.deficienciesNumber,
                                                field: `detentions[${index}].deficienciesNumber`,
                                                changeField,
                                                type: 'number',
                                                style: { width: '35%' },
                                            })
                                        }
                                    </TableRowColumn>
                                    <TableRowColumn
                                        style={{ width: '34%', border: '1px solid #dfdfdf', padding: '0 5px', cursor: 'pointer' }}
                                    >
                                        {
                                            detention.deficienciesNature && detention.deficienciesNature.map((def, defIndex) => {
                                                return (
                                                    <div key={`deficiences_${defIndex}`}>
                                                        <span style={{ fontSize: '13px', whiteSpace: 'break-spaces' }} >{`${defIndex + 1} - ${def}`}</span> <br />
                                                    </div>
                                                );
                                            })
                                        }
                                    </TableRowColumn>
                                    <TableRowColumn style={{ border: '1px solid #dfdfdf', padding: 0, textAlign: 'center' }}>
                                        {
                                            index === detentions.length - 1 ?
                                                <IconButton
                                                    style={{ padding: 0, width: '35px' }}
                                                >
                                                    <ContentAddIcon
                                                        onClick={addDetention}
                                                        color='green'
                                                    />
                                                </IconButton>
                                                :
                                                <IconButton
                                                    style={{ padding: 0, width: '35px' }}
                                                >
                                                    <ContentRemoveIcon
                                                        onClick={() => {
                                                            removeDetention(index);
                                                        }}
                                                        color='red'
                                                    />
                                                </IconButton>

                                        }
                                    </TableRowColumn>
                                </TableRow>
                            );
                        })
                    }
                </TableBody>
            </Table>
        </div>
    );
}

export default Detentions;

function generateTextFields({ value, field, changeField, type = 'string', style = {} }) {
    return (
        <TextField
            name={field}
            value={value || ''}
            onChange={(e) => {
                changeField([{
                    field,
                    value: e.target.value,
                }]);
            }}
            type={type}
            style={{ width: '100%', fontSize: '13px', ...style }}
            underlineStyle={{ display: 'none' }}
        />
    );
}

function PortsAutoComplete({ index, port, selectPort, clearDetentions }) {
    const [ports, setPorts] = useState([]);
    const [searchText, setSearchText] = useState('');

    const debouncedSearch = useDebounce(searchText, 500);

    useEffect(() => {
        if (debouncedSearch && debouncedSearch.length > 1) {
            api.findPortAdmin({ name: debouncedSearch, skipSubPortsTreeGenerate: true })
                .then((results) => {
                    const _ports = results.data.data.map((p) => {
                        return {
                            ...p,
                            name: `${p.name} (${p.country.name})`,
                        };
                    });
                    setPorts(_ports);
                })
                .catch(e => console.error(e));
        } else {
            setPorts([]);
        }
    }, [debouncedSearch]);

    useEffect(() => {
        if (clearDetentions) {
            setSearchText('');
        }
    }, [clearDetentions]);

    const changeAutoComplete = (_searchText) => {
        setSearchText(_searchText);
    };

    const chooseAutoComplete = (_port) => {
        _port.name = _port.name.split(' (')[0];
        setSearchText('');
        selectPort(_port, index);
    };

    return (
        <AutoComplete
            searchText={searchText || (port && port.name)}
            textFieldStyle={{ fontSize: '13px' }}
            name={`portAutocomplete.${index}`}
            dataSource={ports}
            value={port && port._id}
            dataSourceConfig={{ text: 'name', value: 'item' }}
            onUpdateInput={changeAutoComplete}
            onNewRequest={chooseAutoComplete}
            filter={AutoComplete.noFilter}
            listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
            menuStyle={{ width: 'auto' }}
            underlineStyle={{ display: 'none' }}
            popoverProps={{
                canAutoPosition: true,
            }}
        />
    );
}

function DatesSelector({ type, value, index, maxDate, minDate, setSelectedDate }) {
    return (
        <DatePicker
            autoOk
            maxDate={maxDate}
            minDate={minDate}
            value={value && new Date(value)}
            id={`uniqueid_${index}`}
            onChange={(e, date) => { setSelectedDate(moment(date).utcOffset(0, true).format(), type, index); }}
            underlineStyle={{ display: 'none' }}
            inputStyle={{ fontSize: '13px' }}
            textFieldStyle={{ cursor: 'pointer' }}
            formatDate={(date) => {
                return moment(date).format('DD-MM-YYYY');
            }}
        />
    );
}

const NatureDialog = ({ detentionIndex, detention, detentions, changeField, handleOpenNatureDialog, openNatureDialog }) => {
    const [_detention, set_detention] = useState(_.cloneDeep(detention));
    const [_detentions, set_detentions] = useState(_.cloneDeep(detentions));
    const forceUpdate = React.useState()[1].bind(null, {});

    useEffect(() => {
        set_detentions(detentions);
        set_detention(detention);

        return function () {
            set_detention(detention);
        };
    }, [detention, detentions]);

    useEffect(() => {
        if (_detention && _detention.deficienciesNature.length === 0) {
            set_detention({
                ...detention,
                deficienciesNature: [''],
            });
        }
    }, [_detention]);

    function applyDetentionChanges() {
        const _detentionsCopy = _.cloneDeep(_detentions);

        _detentionsCopy[detentionIndex].deficienciesNature = _detention.deficienciesNature.filter(d => d);

        changeField([
            {
                field: 'detentions',
                value: _detentionsCopy,
            },
        ]);

        handleOpenNatureDialog();
    }

    function removeNatureOfDeficiency(natureIndex) {
        const _detentionCopy = _.cloneDeep(_detention);
        _detentionCopy.deficienciesNature.splice(natureIndex, 1);

        set_detention(_detentionCopy);
        forceUpdate();
    }

    function addNatureOfDeficiency() {
        set_detention({
            ..._detention,
            deficienciesNature: [
                ..._detention.deficienciesNature,
                '',
            ],
        });
    }

    function handleClose() {
        set_detention(detention);
        handleOpenNatureDialog();
    }

    const handleChangeDeficiency = (defIndex, value) => {
        const _detentionCopy = _.cloneDeep(_detention);
        _detentionCopy.deficienciesNature[defIndex] = value;

        set_detention(_detentionCopy);
    };

    const actions = [
        <FlatButton
            label="Submit"
            primary
            onClick={applyDetentionChanges}
        />,
        <FlatButton
            label="Close"
            primary
            onClick={handleClose}
        />,
    ];

    return (
        <Dialog
            open={openNatureDialog}
            actions={actions}
            onRequestClose={handleClose}
        >
            {
                _detention && _detention.deficienciesNature && _detention.deficienciesNature.map((def, defIndex) => {
                    return (
                        <div
                            key={`deficiences_${defIndex}`}
                            style={{ display: 'flex', textAlign: 'center' }}
                        >
                            <TextField
                                style={{ fontSize: '13px', width: '90%' }}
                                hintText='Nature of deficiences'
                                value={def || ''}
                                name='deficiency'
                                onChange={e => handleChangeDeficiency(defIndex, e.target.value)}
                            />
                            <div style={{ width: '10%' }}>
                                {
                                    defIndex === 0 ?
                                        <IconButton
                                            style={{ padding: 0 }}
                                        >
                                            <ContentAddIcon
                                                onClick={addNatureOfDeficiency}
                                                color='green'
                                            />
                                        </IconButton>
                                        :
                                        <IconButton
                                            style={{ padding: 0 }}
                                        >
                                            <ContentRemoveIcon
                                                onClick={() => {
                                                    removeNatureOfDeficiency(defIndex);
                                                }}
                                                color='red'
                                            />
                                        </IconButton>
                                }
                            </div>
                        </div>
                    );
                })
            }
        </Dialog>
    );
};



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Detentions.jsx